import { View, Text } from 'react-native'
import React from 'react'
import Svg, { Circle, Path } from 'react-native-svg'; // Import the necessary components


const SearchIcon = ({ color, height, width }) => {
    return (
        <View>
            <Svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 24 24" fill="none">
                <Circle cx="11" cy="11" r="6" stroke="#222222" />
                <Path d="M11 8C10.606 8 10.2159 8.0776 9.85195 8.22836C9.48797 8.37913 9.15726 8.6001 8.87868 8.87868C8.6001 9.15726 8.37913 9.48797 8.22836 9.85195C8.0776 10.2159 8 10.606 8 11" stroke="#222222" stroke-linecap="round" />
                <Path d="M20 20L17 17" stroke="#222222" stroke-linecap="round" />
            </Svg>
        </View>
    )
}

export default SearchIcon